"use strict";

var _defineProperty = require("/root/website/node_modules/@babel/runtime/helpers/defineProperty");

var _CreditRangeByProduct;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CreditRangeByProduct = void 0;

var _productTypes = require("../constants/product-types");

var CreditRangeByProduct = (_CreditRangeByProduct = {}, _defineProperty(_CreditRangeByProduct, _productTypes.ProductTypes.HOME, {
  min: 30000,
  max: 3000000
}), _defineProperty(_CreditRangeByProduct, _productTypes.ProductTypes.AUTO, {
  min: 5000,
  max: 150000
}), _CreditRangeByProduct);
exports.CreditRangeByProduct = CreditRangeByProduct;